import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { useOrderHistory } from 'pages/orders/order_history/context';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Form, Row } from 'react-bootstrap';
import { OrderStatus } from 'apis/OrderApi';
import { useApp } from 'app';

export const SearchFilters = props => {

    const { highestRole } = useApp();
    const { formatMessage } = useIntl();

    const { clearFilters, countries, filters, handleCountryChange, handleDirectionChange, handleStatusChange,
        isReceived, isTestingCenter, licenses, loading, orderStatus, selectedPartnerName, setFilters, states } = useOrderHistory();

    const isSysAdmin = highestRole.id === 1;
    const canToggleDirection = !isSysAdmin && !isTestingCenter;

    return (
        <div className={'search-filters'}>

            <div className="d-flex justify-content-between flex-column gap-3 flex-xl-row">
                <h6 className={'d-flex align-items-center gap-1'}>
                    <span>
                        {<FormattedMessage defaultMessage="Viewing orders for" id="viewing_orders_for.cfa4add4" />}
                        :
                    </span>
                    <em className={'fw-semibold'}>
                        {selectedPartnerName}
                    </em>
                </h6>

                <GMetrixButton
                    className={'align-self-baseline'}
                    disabled={loading}
                    iconClass="fa-solid fa-times"
                    onClick={clearFilters}
                    size={'sm'}
                    variant="outline-secondary"
                >
                    {<FormattedMessage defaultMessage="Clear Filters" id="clear_filters.43f50aba" />}
                </GMetrixButton>
            </div>

            <hr />

            <Row className="align-items-end mb-2">

                <Col className="mb-2" lg={2} sm={6} xs={12}>
                    <GMetrixInput
                        disabled={loading}
                        label={formatMessage({ id: 'purchase_order.17844493', defaultMessage: 'Purchase Order' })}
                        labelClass="fw-bold"
                        onChange={e => setFilters({ purchaseOrder: e.target.value })}
                        size="sm"
                        value={filters.purchaseOrder}
                    />
                </Col>

                <Col className="mb-2" lg={2} sm={6} xs={12}>
                    <GMetrixInput
                        disabled={loading}
                        label={formatMessage({ id: 'order_id.ab576b3d', defaultMessage: 'Order ID', description: 'Formulario' })}
                        labelClass="fw-bold"
                        onChange={e => setFilters({ orderId: e.target.value })}
                        size="sm"
                        value={filters.orderId}
                    />
                </Col>

                <Col className="mb-2" lg={2} sm={6} xs={12}>
                    <GMetrixInput
                        disabled={loading}
                        label={formatMessage({ id: 'ordered_by.381902ec', defaultMessage: 'Ordered By', description: 'Formulario' })}
                        labelClass="fw-bold"
                        onChange={e => setFilters({ orderedBy: e.target.value })}
                        size="sm"
                        value={filters.orderedBy}
                    />
                </Col>

                <Col className="mb-2" lg={2} sm={6} xs={12}>
                    <Form.Group>
                        <Form.Label className="fw-bold">
                            {<FormattedMessage defaultMessage="Status" id="status.ad856ad7" />}
                        </Form.Label>
                        <Form.Select
                            disabled={loading}
                            onChange={e => handleStatusChange(parseInt(e.target.value) as OrderStatus)}
                            size="sm"
                            value={orderStatus}
                        >
                            <option value={OrderStatus.Pending}>
                                {formatMessage({ id: 'pending.0fe13d57', defaultMessage: 'Pending' })}
                            </option>
                            <option value={OrderStatus.Processed}>
                                {formatMessage({ id: 'processed.1b51ab97', defaultMessage: 'Processed' })}
                            </option>
                            <option value={OrderStatus.Canceled}>
                                {formatMessage({ id: 'cancelled.6f04ce2e', defaultMessage: 'Cancelled' })}
                            </option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col className="mb-2" lg={2} sm={6} xs={12}>
                    <Form.Group>
                        <Form.Label className="fw-bold">
                            {<FormattedMessage defaultMessage="Placed" id="placed.e1e27680" />}
                            /
                            {<FormattedMessage defaultMessage="Received" id="received.31acbfa3" />}
                        </Form.Label>
                        {canToggleDirection ? (
                            <Form.Select
                                disabled={loading}
                                onChange={e => handleDirectionChange(e.target.value === 'true')}
                                size="sm"
                                value={isReceived.toString()}
                            >
                                <option value="false">
                                    {formatMessage({ id: 'placed.e1e27680', defaultMessage: 'Placed' })}
                                </option>
                                <option value="true">
                                    {formatMessage({ id: 'received.31acbfa3', defaultMessage: 'Received' })}
                                </option>
                            </Form.Select>
                        ) : (
                            <Form.Select disabled size="sm">
                                <option>
                                    {isReceived ?
                                        formatMessage({ id: 'received.31acbfa3', defaultMessage: 'Received' })
                                        :
                                        formatMessage({ id: 'placed.e1e27680', defaultMessage: 'Placed' })
                                    }
                                </option>
                            </Form.Select>
                        )}
                    </Form.Group>
                </Col>

                <Col className="mb-2" lg={2} sm={6} xs={12}>
                    <Form.Group>
                        <Form.Label className="fw-bold">
                            {<FormattedMessage defaultMessage="License" description={formatMessage({ id: 'formulario.6dc35e9d', defaultMessage: 'Formulario' })} id="license.506a29aa" />}
                        </Form.Label>
                        <Form.Select
                            disabled={loading}
                            onChange={e => setFilters({ license: parseInt(e.target.value) })}
                            size="sm"
                            value={filters.license}
                        >
                            <option value={0}>
                                {formatMessage({ id: 'all.8e011e43', defaultMessage: 'All', description: 'New' })}
                            </option>
                            {licenses.map(({ Id, Name }) => (
                                <option key={Id} value={Id}>
                                    {Name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>

            </Row>

            <Row className="align-items-end mb-3">

                <Col className="mb-2" lg={2} sm={6} xs={12}>
                    <GMetrixInput
                        disabled={loading}
                        label={formatMessage({ id: 'start_date.66ba5b72', defaultMessage: 'Start Date' })}
                        labelClass="fw-bold"
                        onChange={e => setFilters({ startDate: e.target.value })}
                        size="sm"
                        type="date"
                        value={filters.startDate}
                    />
                </Col>

                <Col className="mb-2" lg={2} sm={6} xs={12}>
                    <GMetrixInput
                        disabled={loading}
                        label={formatMessage({ id: 'end_date.10ec21c1', defaultMessage: 'End Date' })}
                        labelClass="fw-bold"
                        onChange={e => setFilters({ endDate: e.target.value })}
                        size="sm"
                        type="date"
                        value={filters.endDate}
                    />
                </Col>

                {isReceived && (
                    <>
                        <Col className="mb-2" lg={2} sm={6} xs={12}>
                            <Form.Group>
                                <Form.Label className="fw-bold">
                                    {<FormattedMessage defaultMessage="Country" description={formatMessage({ id: 'new.03d9347f', defaultMessage: 'New' })} id="country.cfeb54cc" />}
                                </Form.Label>
                                <Form.Select
                                    disabled={loading}
                                    onChange={e => handleCountryChange(parseInt(e.target.value))}
                                    size="sm"
                                    value={filters.country}
                                >
                                    <option value={0}>
                                        {formatMessage({ id: 'choose_one.e57d2911', defaultMessage: 'Choose one', description: 'formulario' })}
                                    </option>
                                    {countries.map(({ Id, Name }) => (
                                        <option key={Id} value={Id}>
                                            {Name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col className="mb-2" lg={2} sm={6} xs={12}>
                            <Form.Group>
                                <Form.Label className="fw-bold">
                                    {<FormattedMessage defaultMessage="State/Province" id="stateprovince.d2dfa3c8" />}
                                </Form.Label>
                                <Form.Select
                                    disabled={filters.country === 0 || loading}
                                    onChange={e => setFilters({ state: parseInt(e.target.value) })}
                                    size="sm"
                                    value={filters.state}
                                >
                                    <option value={0}>
                                        {formatMessage({ id: 'choose_one.e57d2911', defaultMessage: 'Choose one', description: 'formulario' })}
                                    </option>
                                    {states.map(({ Id, Name }) => (
                                        <option key={Id} value={Id}>
                                            {Name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col className="mb-2" lg={2} sm={6} xs={12}>
                            <GMetrixInput
                                disabled={loading}
                                label={formatMessage({ id: 'customer_id.16ab92c3', defaultMessage: 'Customer ID', description: 'New' })}
                                labelClass="fw-bold"
                                onChange={e => setFilters({ customerId: e.target.value })}
                                size="sm"
                                value={filters.customerId}
                            />
                        </Col>
                    </>
                )}

            </Row>

        </div>
    );

};
